import React from "react";
import Header from "../components/common/Header";
import Challenges from "../components/Challenges";

const ChallengesPage = () => {
  return (
    <div className="page-container">
      <div className="content-card">
        <Challenges />
      </div>
    </div>
  );
};

export default ChallengesPage;
